<template>
	<v-dialog 
		v-resize="onResize"
		v-model="visible"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		lazy
		max-width="600"
		:fullscreen="isFullscreen">

		<v-card>
			<v-card-title class="pa-0">
				<v-toolbar dense dark color="primary" card>
					<v-toolbar-title>{{ $t('ACTION_NEW_TITLE') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn flat small @click="cancel" class="hidden-xs-only">{{ $t('GENERAL_BUTTON_CANCEL') }}</v-btn>
						<v-btn flat small @click="submit" class="hidden-xs-only">{{ $t('GENERAL_BUTTON_SAVE') }}</v-btn>
						<v-btn icon small @click="cancel" class="hidden-sm-and-up"><v-icon>mdi-close</v-icon></v-btn>
						<v-btn icon small @click="submit" class="hidden-sm-and-up"><v-icon>mdi-check</v-icon></v-btn>
					</v-toolbar-items>
				</v-toolbar>
			</v-card-title>

			<v-card-text>
				<v-alert
					class="pa-2 mb-3"
					outline
					dismissible
					type="error"
					transition="scale-transition"
					:value="!!error"
					@input="clearError">

					{{ error && error.message }}
				</v-alert>

				<v-form ref="form">
					<v-container fluid grid-list-lg>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('ACTION_HEADER_GENERAL_INFO') }}</span>
						</v-layout>

						<v-layout wrap>
							<v-flex xs12>
								<markdown-editor
									:label="$t('ACTION_LABEL_TITLE')"
									:rules="[rules.required]"
									v-model="item.title"/>

								<!-- <v-text-field
									:label="$t('ACTION_LABEL_TITLE')"
									:rules="[rules.required]"
									box hide-details
									v-model="item.title"/> -->
							</v-flex>
							<v-flex xs12>
								<markdown-editor
									:label="$t('ACTION_LABEL_CLAIM')"
									:rules="[rules.required]"
									v-model="item.claim" />
							</v-flex>
							<v-flex xs12>
								<v-combobox
									:label="$t('ACTION_LABEL_CATEGORY')"
									chips box hide-details clearable
									:items="categories"
									v-model="item.category" />
							</v-flex>
							<v-flex xs12>
								<markdown-editor
									:label="$t('ACTION_LABEL_DESCRIPTION')"
									:rules="[rules.required]"
									v-model="item.description" />
							</v-flex>
							<v-flex xs12>
								<markdown-editor
									:label="$t('ACTION_LABEL_DURATION')"
									:rules="[rules.required]"
									v-model="item.duration" />
							</v-flex>
						</v-layout>
					</v-container>

					<v-container fluid grid-list-lg>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('ACTION_HEADER_REQUIREMENTS') }}</span>
						</v-layout>

						<v-layout wrap>
							<v-flex xs12>
								<markdown-editor :label="$t('ACTION_LABEL_REQUIRED_PEOPLE')" v-model="item.requiredPeople" />
							</v-flex>
							<v-flex xs12>
								<markdown-editor :label="$t('ACTION_LABEL_REQUIRED_STUFF')" v-model="item.requiredStuff" />
							</v-flex>
						</v-layout>
					</v-container>

					<v-container fluid grid-list-lg align-center justify-center>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('ACTION_HEADER_TONE_ESTIMATION') }}</span>
						</v-layout>

						<v-layout wrap align-center justify-start>
							<v-flex shrink>
								<v-rating 
									hover
									class="d-inline-block"
									empty-icon="mdi-human-greeting"
									full-icon="mdi-human-greeting"
									background-color="grey ligthen-2"
									color="orange darken-1"
									v-model="item.tone"/>
							</v-flex>
							<v-flex shrink class="font-italic">{{ $ta('GENERAL_TONE_LEVELS', item.tone || 0) }}</v-flex>
						</v-layout>
						<v-layout wrap>
							<v-flex xs12>
								<markdown-editor :label="$t('ACTION_LABEL_TONE_DESCRIPTION')" v-model="item.toneComment" />
							</v-flex>
						</v-layout>
					</v-container>

					<v-container fluid grid-list-lg align-center justify-center>
						<v-layout wrap class="mb-3">
							<span class="subheading">{{ $t('ACTION_HEADER_RISK_ESTIMATION') }}</span>
						</v-layout>

						<v-layout wrap align-center justify-start>
							<v-flex shrink>
								<v-rating 
									hover
									class="d-inline-block"
									empty-icon="mdi-alert-outline"
									full-icon="mdi-alert"
									background-color="red darken-3"
									color="red darken-3"
									v-model="item.risk"/>
							</v-flex>
							<v-flex shrink class="font-italic">{{ $ta('GENERAL_RISK_LEVELS', item.risk || 0) }}</v-flex>
						</v-layout>
						<v-layout wrap>
							<v-flex xs12>
								<markdown-editor :label="$t('ACTION_LABEL_RISK_DESCRIPTION')" v-model="item.riskComment" />
							</v-flex>
						</v-layout>
					</v-container>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>


<script>
import { mapGetters } from 'vuex';
import MarkdownEditor from '@/components/MarkdownEditor';

export default {
	name: "dialog-edit-action",
	components: { MarkdownEditor },
	data(self) { return {
		currentWidth: window.innerWidth,
		showErrorOnLabel: false,
		rules: {
			required(value) {
				return typeof value === 'string' && !!value.trim() || self.$t('GENERAL_VALIDATION_ERROR_REQUIRED');
			},
		},
	}},
	computed: {
		isFullscreen() {
			return this.currentWidth < 600;
		},
		...mapGetters('actions', {
			item: 'editDialogCopy',
			categories: 'categoryNames',
			visible: 'editDialogVisible',
			error: 'saveError',
		}),
	},
	methods: {
		clearError() {
			this.$store.dispatch('actions/clearErrors');
		},
		onResize() {
			this.currentWidth = window.innerWidth;
		},
		submit() {
			if (!this.$refs['form'].validate()) { return }
			this.$store.dispatch('actions/saveAction', { item: this.item });
		},
		cancel() {
			this.$store.dispatch('actions/cancelActionChanges', { item: this.item });
			this.$refs['form'].resetValidation();
		},
	},
}
</script>


<style lang="less" scoped>
</style>
